module.exports = __webpack_public_path__ + "img/hiking_1413_2.49383664.jpg";